module.exports = __webpack_public_path__ + "img/hdfc-2.d54ddb17.jpg";